import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import _ from "lodash";
import constants from "../../../../constants";
import useAxiosPrivate from "../../../../Hooks/useAxiosPrivate";
import { Link, useParams } from "react-router-dom";
import Whatsapp from "../../../../Svg/Whatsapp";
import Checkbox from "../../../CommonComponents/Checkbox";
import Button from "../../../Button";
import AlertContext from "../../../../context/AlertContext";
import Loading from "../../../Notification-Loading/Loading/Loading";
import Modal from "../../../CommonComponents/Modal";
import ModalBody from "../../../CommonComponents/ModalBody";
import IssueForm from "../../../Student/Issue/IssueForm";
import DoubtForm from "../../../Student/AskDoubts/DoubtForm";
import ExtentionRequestForm from "../../../Student/InstructionPage/ExtentionRequestForm";
import moment from "moment";
import DatePicker from "react-datepicker";
import useCommonFunctionHooks from "../../../../Hooks/useCommonFunctionHooks";
import useS3FileManagement from "../../../../Hooks/useS3FileManagement";

const IssueTable = () => {
  const { id } = useParams();
  const { setShowNotify, setIsLoaded, isLoaded } = useContext(AlertContext);
  const axios = useAxiosPrivate();
  const { getS3FileAsFile } = useS3FileManagement();
  const useCommonFunctionHks = useCommonFunctionHooks();
  const { viewLearnerData, setData } = useContext(AlertContext);

  // const des =
  //   "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum";

  const [issueData, setIssueData] = useState([]);
  const [showForm, setShowForm] = useState(false);
  const [details, setDetails] = useState({});
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [selectedType, setSelectedType] = useState(null);
  // const [isDoubt, setIsDoubt] = useState(false);
  const [requestType, setRequestType] = useState(null);
  const [extendPopUp, setExtentPopUp] = useState(false);
  const [buttonClicked, setButtonClicked] = useState(false);
  const Alert = useContext(AlertContext);

  let resolvedIds = _.chain(issueData)
    .filter((issue) => issue.checked)
    .map((issue) => issue.id)
    .value();

  useEffect(() => {
    const getIssues = () => {
      setIsLoaded(true);
      axios
        .get(`node/admin/batch/${id}/issues`, {
          headers: {
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          console.log("response", response.data);
          if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
            setIssueData(
              response.data.data?.map((issue) => ({ ...issue, checked: false }))
            );
          }
        })
        .catch((error) => {
          console.error("error", error);
          // if (axios(error)) {
          //   console.log("Save duration request canceled");
          //   return;
          // }
          if (error.message.includes("403")) {
            setShowNotify({
              show: true,
              title: "Warning !",
              msg: "You have been logged-out due to inactivity. Login again.",
              isUnAuth: true,
            });
          } else {
            setShowNotify({
              show: true,
              title: "Error !",
              msg: "Something went wrong. Please try again later or contact gradious team",
            });
          }
        })
        .finally(() => {
          setIsLoaded(false);
        });
    };
    getIssues();
  }, [axios, id, setIsLoaded, setShowNotify]);

  const onRowClick = (issueId) => {
    let issues = JSON.parse(JSON.stringify(issueData));
    issues = _.map(issues, (issue) => {
      if (issue.id === issueId) issue.checked = !issue.checked;
      return issue;
    });
    setIssueData(issues);
  };

  const handleExtension = async (data) => {
    let apiurl, apidata;
    const extensionDate =
      localStorage.getItem("extensionDate") ??
      Alert.extensionDate ??
      moment(new Date()).format("YYYY-MM-DD HH:mm:ss");

    apiurl = "node/admin/duedate/extd";
    apidata = {
      // reset: false,
      // testid: data.testid,
      // libtypeid: data.libtype,
      learnerid: data.learnerid,
      lpconfigid: data.lpconfigid,
      exdate: extensionDate.toString(),
    };

    setIsLoaded(true);
    try {
      const res = await axios.post(
        apiurl,
        JSON.stringify(apidata),
        useCommonFunctionHks.getHeaderDetailsForAxios()
      );

      if (res.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
        setShowNotify({
          show: true,
          title: "Info",
          msg: res.data.msg,
        });
        return true;
      }

      setShowNotify({
        show: true,
        title: "Info",
        msg: "Something went wrong. Please, try again",
      });
      return false;
    } catch (error) {
      useCommonFunctionHks.getCatchBlockDetails(error);
      return false;
    } finally {
      setIsLoaded(false);
    }
  };

  const onClickIssue = async (event, row) => {
    console.log("row:", row);
    event.preventDefault();
    event.stopPropagation();
    let attachmentPath = null;
    if (row.attachment) {
      attachmentPath = await getS3FileAsFile(row.attachment, "HOST");
    }
    setDetails({
      id: row.id,
      title: row.title,
      type: row.type,
      bid: row.bid,
      description: row.description,
      attachment: attachmentPath,
      mid: row.request_type === constants.REQUEST_TYPE.DOUBT ? row.mid : null,
      learnerName: row.name,
      testDueDate: row.duedate,
      lpconfigid: row.lpcid,
      learnerid: row.lid,
      requestType: row.request_type,
    });
    setRequestType(row.request_type);
    setSelectedBatch(row.bid);
    setSelectedType(row.type);
    setShowForm(true);
  };

  const onMarkAsResolved = async (event, idsToResolve = resolvedIds) => {
    event?.preventDefault();
    if (idsToResolve.length) {
      try {
        setIsLoaded(true);
        const response = await axios.put(
          `node/admin/batch/${id}/issues`,
          idsToResolve,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );
        if (response.data.resultCode === constants.RESULT_STATUS.SUCCESS) {
          const isExtensionResolution =
            idsToResolve.length === 1 &&
            idsToResolve[0] === details.id &&
            details?.requestType === constants.REQUEST_TYPE.EXTENSION_REQUEST;

          setIssueData((pre) =>
            _.filter(pre, (issue) => !idsToResolve.includes(issue.id))
          );
          setShowNotify({
            show: true,
            msg: `${
              isExtensionResolution
                ? "Due Date has been Extended and Request is resolved successfully"
                : `Request${
                    idsToResolve.length > 1 ? "s are" : " is"
                  } resolved successfully.`
            }`,

            title: "Info",
          });
        } else {
          setShowNotify({
            show: true,
            msg:
              response.data.msg ??
              "Something went wrong. Please try again later or contact gradious team",
            title: "Error !",
          });
        }
      } catch (error) {
        if (error.message.includes("403")) {
          setShowNotify({
            show: true,
            title: "Warning !",
            msg: "You have been logged-out due to inactivity. Login again.",
            isUnAuth: true,
          });
        } else {
          setShowNotify({
            show: true,
            title: "Error !",
            msg: "Something went wrong. Please try again later or contact gradious team",
          });
        }
      } finally {
        setIsLoaded(false);
      }
    }
  };

  const onCloseForm = () => {
    setShowForm(false);
    setDetails({});
    setSelectedBatch({});
    setSelectedType({});
  };

  const extendDueDate = async (e) => {
    e.preventDefault();
    setExtentPopUp(false);
    const isExtended = await handleExtension(details);
    if (isExtended) {
      await onMarkAsResolved(e, [details.id]);
    }
  };

  return (
    <React.Fragment>
      <div className="issueUtils">
        <Button
          size="sm"
          hierarchy={{ type: "secondaryGrey", buttonText: "Mark As Resolved" }}
          onClick={onMarkAsResolved}
          disable={!resolvedIds.length}
        />
      </div>
      <Modal
        isOpen={showForm}
        showCloseIcon
        onClose={onCloseForm}
        title={
          requestType === constants.REQUEST_TYPE.DOUBT
            ? "Doubt"
            : requestType === constants.REQUEST_TYPE.ISSUE
            ? "Issue"
            : "Extention Request"
        }
        className="admin-side-support-request"
        closeIcon={
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 5L5 15M5 5L15 15"
              stroke="#667085"
              strokeWidth="1.66667"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        }
      >
        <ModalBody
          content={
            requestType === constants.REQUEST_TYPE.DOUBT ? (
              <DoubtForm
                setShowForm={setShowForm}
                isEdit={true}
                details={details}
                setDetails={setDetails}
                selectedBatch={selectedBatch}
                setSelectedBatch={setSelectedBatch}
                selectedType={selectedType}
                setSelectedType={setSelectedType}
                initialDetails={{}}
              />
            ) : requestType === constants.REQUEST_TYPE.ISSUE ? (
              <IssueForm
                setShowForm={setShowForm}
                isEdit={true}
                details={details}
                setDetails={setDetails}
                selectedBatch={selectedBatch}
                setSelectedBatch={setSelectedBatch}
                selectedType={selectedType}
                setSelectedType={setSelectedType}
                initialDetails={{}}
              />
            ) : requestType === constants.REQUEST_TYPE.EXTENSION_REQUEST ? (
              <ExtentionRequestForm
                setShowForm={setShowForm}
                isEdit={true}
                details={details}
                setDetails={setDetails}
                selectedBatch={selectedBatch}
                setSelectedBatch={setSelectedBatch}
                selectedType={selectedType}
                setSelectedType={setSelectedType}
                initialDetails={{}}
                setExtentPopUp={setExtentPopUp}
              />
            ) : (
              <p>Unsupported support request type</p>
            )
          }
        />
      </Modal>
      {extendPopUp && (
        <Modal
          title="Set new Deadline"
          isOpen={extendPopUp}
          showCloseIcon={true}
          onClose={() => setExtentPopUp(false)}
          closeIcon={
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 5L5 15M5 5L15 15"
                stroke="#667085"
                strokeWidth="1.66667"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          }
        >
          <div className="extDialogContainer">
            <div>
              <table>
                <tr>
                  <td className="extdialog-details-row-label">Learner:</td>{" "}
                  <td className="extdialog-details-row-value">
                    {" "}
                    &nbsp;{details.learnerName}
                  </td>
                </tr>
                <tr>
                  <td className="extdialog-details-row-label">Test:</td>{" "}
                  <td className="extdialog-details-row-value">
                    {" "}
                    &nbsp;{details.title}
                  </td>
                </tr>
                <tr>
                  <td className="extdialog-details-row-label">
                    Test Due Date:{" "}
                  </td>{" "}
                  <td className="extdialog-details-row-value">
                    {" "}
                    &nbsp;
                    {moment(details.testDueDate).format("MMMM Do YYYY, h:mm a")}
                  </td>
                </tr>
              </table>
            </div>
            <>
              <div className="extdialog-datepicker-div">
                <h6>New Deadline:&nbsp; </h6>
                <DatePicker
                  showIcon
                  showTimeInput
                  timeInputLabel="Time:"
                  minDate={moment().toDate()}
                  className="codingDatePicker"
                  dateFormat="dd/MMM/yyyy h:mm aa"
                  selected={new Date(Alert.extensionDate)}
                  onChange={(date) => {
                    localStorage.setItem(
                      "extensionDate",
                      moment(date).format("YYYY-MM-DD HH:mm:ss")
                    );
                    Alert.setExtensionDate(
                      moment(date).format("YYYY-MM-DD HH:mm:ss")
                    );
                  }}
                />
              </div>

              <div className="comments-score-section-score-reject-box-score-button-section-exdialog"></div>
            </>
            <Button
              size="lg"
              hierarchy={{ type: "primary", buttonText: "Extend" }}
              onClick={(e) => {
                extendDueDate(e);
              }}
            />
          </div>
        </Modal>
      )}
      <TableContainer className="issueTableContainer">
        <Table className="issueTable">
          <TableHead className="issueTableHead">
            <TableRow className="issueTableHRow">
              <TableCell className="issueTableHCell issueTableHCellCheckbox">
                <Checkbox
                  size="sm"
                  checked={
                    issueData.length
                      ? resolvedIds.length === issueData.length
                      : false
                  }
                  onChange={(value) =>
                    setIssueData((pre) =>
                      _.map(pre, (issue) => ({ ...issue, checked: value }))
                    )
                  }
                  disabled={!issueData.length}
                />
              </TableCell>
              <TableCell className="issueTableHCell issueTableHCellName ">
                Name
              </TableCell>
              <TableCell className="issueTableHCell issueTableHCellEmail">
                Email
              </TableCell>
              <TableCell className="issueTableHCell issueTableHCellMobile">
                mobile
              </TableCell>
              <TableCell className="issueTableHCell issueTableHCellSummary">
                Title
              </TableCell>
              <TableCell className="issueTableHCell issueTableHCellDes">
                Description
              </TableCell>
              <TableCell className="issueTableHCell">Request Type</TableCell>
              <TableCell className="issueTableHCell issueTableHCellCDate">
                Created date
              </TableCell>
              {/* <TableCell className="issueTableHCell issueTableHCellJiraid">
                Jiraid
              </TableCell> */}
              {/* <TableCell className={classes.headerCol}>Options</TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {issueData.length > 0 ? (
              _.map(issueData, (issue, index) => (
                <TableRow
                  className="issueTableBRow"
                  key={index}
                  onClick={() => onRowClick(issue.id)}
                >
                  <TableCell
                    className="issueTableBCell issueTableBCellCheckbox"
                    title={issue.name}
                  >
                    <Checkbox
                      size="sm"
                      onChange={(value) => onRowClick(issue.id)}
                      checked={issue.checked}
                    />
                  </TableCell>
                  <TableCell
                    className="issueTableBCell issueTableBCellName"
                    title={issue.name}
                  >
                    {issue.name}
                  </TableCell>

                  <TableCell
                    className="issueTableBCell issueTableBCellEmail"
                    title={issue.email}
                  >
                    {issue.email}
                  </TableCell>
                  <TableCell
                    className="issueTableBCell issueTableBCellMobile"
                    title={issue.mobile}
                  >
                    <div className="issueTableBCellMobileSec">
                      {issue.mobile && issue.mobile !== "" ? (
                        <>
                          <Whatsapp />
                          <Link
                            target="_blank"
                            to={`https://wa.me/${
                              issue.mobile.includes("+91")
                                ? issue.mobile
                                : "+91" + issue.mobile
                            }`}
                          >
                            {issue.mobile}
                          </Link>
                        </>
                      ) : (
                        "-"
                      )}
                    </div>
                  </TableCell>
                  <TableCell
                    className="issueTableBCell issueTableBCellSummary"
                    title={issue.title}
                  >
                    {issue.title}
                  </TableCell>
                  <TableCell
                    className="issueTableBCell issueTableBCellDes"
                    title={issue.description}
                  >
                    {issue.description?.substring(0, 100)}
                  </TableCell>
                  <TableCell
                    className="issueTableBCell"
                    title={issue.request_type}
                  >
                    {issue.request_type === 0
                      ? "Issue"
                      : issue.request_type === 1
                      ? "Doubt"
                      : "Extension Request"}
                  </TableCell>
                  <TableCell className="issueTableBCell issueTableBCellCDate">
                    {/* {moment(issue.createddate).format("DD/MM/YYYY - HH:MM:SS")} */}
                    {issue.createddate}
                    <Button
                      size="sm"
                      hierarchy={{ type: "linkGrey", buttonText: "View" }}
                      onClick={(event) => onClickIssue(event, issue)}
                      className="view-button"
                    />
                  </TableCell>

                  {/* <TableCell className="issueTableBCell issueTableBCellJiraid">
                    <Link
                      target="_blank"
                      to={`https://gradious.atlassian.net/jira/servicedesk/projects/LCS/queues/custom/1/${issue.jiraid}`}
                    >
                      {issue.jiraid}
                    </Link>
                  </TableCell> */}
                </TableRow>
              ))
            ) : (
              <TableRow className="issueTableBRow">
                <TableCell className="issueTableBCellNoData" colSpan={8}>
                  No support requests
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {isLoaded && <Loading overlay/>}
    </React.Fragment>
  );
};

export default IssueTable;
